export const APP_STATUS = "production";
// local
export const LOCAL_BACKEND_URL = "http://168.231.79.51:8080";
export const LOCAL_API_URL = "http://168.231.79.51:8080/api";
export const LOCAL_DOMAIN_URL = "http://168.231.79.51:3005";

// production
export const PRODUCTION_BACKEND_URL = "https://pbe.121-aataxservices.com";
export const PRODUCTION_API_URL = "https://pbe.121-aataxservices.com/api";
export const PRODUCTION_DOMAIN_URL = "https://portal.121-aataxservices.com";

// others
export const cloudName = "dxxortq4j";
export const uploadPreset = "agaimages";
